/** ⌘K on a Mac, Ctrl K everywhere else — the two conventions people already know. */
export function isMac(): boolean {
  return /Mac|iPhone|iPad/u.test(navigator.platform);
}

/** The shortcut as this person's keyboard spells it. */
export function shortcutLabel(): string {
  return isMac() ? "⌘K" : "Ctrl K";
}
